import { render, staticRenderFns } from "./PersonnelInfo.vue?vue&type=template&id=2df2310e&scoped=true"
import script from "./PersonnelInfo.vue?vue&type=script&lang=js"
export * from "./PersonnelInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonnelInfo.vue?vue&type=style&index=0&id=2df2310e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df2310e",
  null
  
)

export default component.exports